/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
var collectionFilter = {
    init: function (settings) {
        collectionFilter.config = {
            collectionUrl    : $('.collection__filter-wrapper').data('collection-url'),
            filterItemClass  : '.js-collection-tag-filter',
            productsContainer: $('.js-collection-grid__products'),
            url              : window.location.origin,
        };

        $.extend(collectionFilter.config, settings);

        collectionFilter.setTagFilter();
    },

    setTagFilter: function () {
        $(document).on('change', collectionFilter.config.filterItemClass, function () {
            const selectedVal = $(this).children('option:selected').val();
            if (selectedVal !== '/') {
                window.location.href = collectionFilter.config.url + collectionFilter.config.collectionUrl + '/' + selectedVal;
            } else {
                window.location.href = collectionFilter.config.url + collectionFilter.config.collectionUrl;
            }
        });
    },
};

theme.Cart = (function () {
    const holidayDataSelector = $('.js-cart-shipping-holidays');

    if (holidayDataSelector.length === 0) {
        return;
    }

    const holidays    = JSON.parse(holidayDataSelector.data('holidays')),
          weekendText = holidayDataSelector.data('weekend-text'),
          today       = new Date(),
          timeRange   = (today.getUTCHours() >= 17 || today.getUTCHours() <= 4) ? 3 : 2;

    function disableHolidaysWeekends(date) {
        var currentMonth = date.getMonth(),
            currentDate  = date.getDate(),
            currentDay   = date.getDay(),
            returnedArr  = [true, ''];

        if (currentDay < 2 || currentDay > 5) {
            return [false, '', weekendText];
        }

        $.each(holidays, function (idx, obj) {
            if (currentMonth === obj.month - 1 && currentDate === obj.day) {
                returnedArr = [false, 'holiday', obj.title];
                return false;
            }
        });

        return returnedArr;
    }

    function setMinDate() {
        return {minDate: timeRange};
    }

    $(function () {
        if ($.fn.datepicker && holidayDataSelector.length) {
            $('.cart__delivery-picker').show();

            today.setHours(0, 0, 0, 0);

            var earliestDate    = today.setTime(today.getTime() + timeRange * 86400000),
                datePickerInput = $('.js-cart-shipping-date-picker');

            datePickerInput.datepicker({
                maxDate      : '+1Y',
                showAnim     : 'drop',
                beforeShowDay: disableHolidaysWeekends,
                beforeShow   : setMinDate,
                onSelect     : function (date) {
                    $(this).attr('value', date);
                    $('.js-delivery-date-error').hide();

                    $.ajax({
                        type    : 'POST',
                        url     : '/cart/update.js',
                        data    : {attributes: {date: date}},
                        dataType: 'json'
                    });

                    if (window.theme && theme.ShippingEstimator && theme.ShippingEstimator.refresh) {
                        theme.ShippingEstimator.refresh();
                    }
                }
            });

            $('.js-cart-button').on('click', function (e) {
                var selectedDate = datePickerInput.datepicker('getDate');

                if ((datePickerInput.val() !== '') && (selectedDate.getTime() < earliestDate)) {
                    e.preventDefault();
                    datePickerInput.val('').attr('value', '');
                    $('.js-delivery-date-error').show();
                }
            });
        }
    });
});

starColorOverride = (function () {
    $('.stamped-fa-star').css('color', '');
    $('.stamped-fa-star-half-o').css('color', '');
});

rebuyStyle = (function () {
    let rebuyWidget = ($('div[data-rebuy-id]').closest('.product-single__box__block'));
    rebuyWidget.css({'display': 'block', 'width': '100%'});
});

theme.ShippingEstimator = (function () {
    var STORAGE_KEY     = 'pp_ship_estimate';
    var SHIP_COUNTRY    = 'United States';
    var $root, $zip, $province, $btn, $status, $rates, $summary;
    var defaultSummary  = '';
    var inflight        = false;
    var lastRates       = null;
    var selectedRateIdx = 0;

    function getPreferredDate() {
        var raw = $('.js-cart-shipping-date-picker').val();
        if (!raw) {
            return null;
        }
        var d;
        try {
            var parts = raw.split('/');
            if (parts.length === 3) {
                var mm = parseInt(parts[0], 10);
                var dd = parseInt(parts[1], 10);
                var yy = parseInt(parts[2], 10);
                if (yy < 100) {
                    yy += 2000;
                }
                d = new Date(yy, mm - 1, dd);
            } else {
                d = new Date(raw);
            }
        } catch (e) {
            return null;
        }
        if (!d || isNaN(d.getTime())) {
            return null;
        }
        return toLocalIso(d);
    }

    function t(key, vars) {
        var template = window.theme && theme.strings && theme.strings[key];
        if (!template) {
            return key;
        }
        if (vars) {
            Object.keys(vars).forEach(function (k) {
                template = template.replace('{{ ' + k + ' }}', vars[k]).replace('{{' + k + '}}', vars[k]);
            });
        }
        return template;
    }

    function formatMoney(priceString) {
        var cents = Math.round(parseFloat(priceString) * 100);
        if (window.Shopify && Shopify.formatMoney && window.theme && theme.money_format) {
            return Shopify.formatMoney(cents, theme.money_format);
        }
        return '$' + (cents / 100).toFixed(2);
    }

    function formatDate(d) {
        try {
            var dt;
            if (d instanceof Date) {
                dt = d;
            } else if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
                var parts = d.split('-');
                dt        = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
            } else {
                dt = new Date(d);
            }
            return dt.toLocaleDateString(undefined, {weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'});
        } catch (e) {
            return String(d);
        }
    }

    function formatDeliveryRange(range) {
        if (!range || !range.length) {
            return '';
        }
        if (range.length === 1 || range[0] === range[1]) {
            return formatDate(range[0]);
        }
        return formatDate(range[0]) + ' – ' + formatDate(range[1]);
    }

    var fallbackHolidays = null;

    function getHolidays() {
        if (fallbackHolidays !== null) {
            return fallbackHolidays;
        }
        try {
            fallbackHolidays = JSON.parse($('.js-cart-shipping-holidays').first().attr('data-holidays') || '[]');
        } catch (e) {
            fallbackHolidays = [];
        }
        return fallbackHolidays;
    }

    function isBusinessDay(date) {
        var day = date.getDay();
        if (day < 2 || day > 5) {
            return false;
        }
        var month      = date.getMonth();
        var dayOfMonth = date.getDate();
        var holidays   = getHolidays();
        for (var i = 0; i < holidays.length; i++) {
            if (holidays[i].month - 1 === month && holidays[i].day === dayOfMonth) {
                return false;
            }
        }
        return true;
    }

    function addBusinessDays(start, count) {
        var d     = new Date(start.getTime());
        var added = 0;
        while (added < count) {
            d.setDate(d.getDate() + 1);
            if (isBusinessDay(d)) {
                added++;
            }
        }
        return d;
    }

    function getLeadDays() {
        var today       = new Date();
        var jan         = new Date(today.getFullYear(), 0, 1).getTimezoneOffset();
        var jul         = new Date(today.getFullYear(), 6, 1).getTimezoneOffset();
        var offsetHours = Math.max(jan, jul) !== today.getTimezoneOffset() ? 4 : 5;
        var dow         = today.getUTCDay();
        var hr          = today.getUTCHours();
        if ((dow === 5 && hr >= (14 + offsetHours)) || (dow === 6 && hr < offsetHours)) {
            return 5;
        }
        if ((dow === 6 && hr >= offsetHours) || (dow === 0 && hr < offsetHours)) {
            return 4;
        }
        if ((dow === 0 && hr >= offsetHours) || (dow === 1 && hr < offsetHours)) {
            return 3;
        }
        if (hr >= (13 + offsetHours) || hr <= offsetHours) {
            return 3;
        }
        return 2;
    }

    function toLocalIso(date) {
        var y = date.getFullYear();
        var m = String(date.getMonth() + 1).padStart(2, '0');
        var d = String(date.getDate()).padStart(2, '0');
        return y + '-' + m + '-' + d;
    }

    function fallbackRangeForRate(rate) {
        var minDays = Math.max(getLeadDays(), 2);
        var maxDays = Math.max(minDays + 3, 7);
        var today   = new Date();
        today.setHours(0, 0, 0, 0);
        var minDate = addBusinessDays(today, minDays);
        var maxDate = addBusinessDays(today, maxDays);
        return [toLocalIso(minDate), toLocalIso(maxDate)];
    }

    function loadCache() {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
        } catch (e) {
            return {};
        }
    }

    function saveCache(data) {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch (e) {
        }
    }

    function setStatus(msg) {
        $status.text(msg || '');
    }

    function bumpToNextBusinessDay(isoDate) {
        if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) {
            return isoDate;
        }
        var parts = isoDate.split('-');
        var d     = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
        while (!isBusinessDay(d)) {
            d.setDate(d.getDate() + 1);
        }
        return toLocalIso(d);
    }

    function policyWindow() {
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        return {
            earliest : toLocalIso(addBusinessDays(today, 2)),
            latestMin: toLocalIso(addBusinessDays(today, 7))
        };
    }

    function normalizeRange(range) {
        if (!range || !range.length) {
            return range;
        }
        var policy = policyWindow();
        var start  = bumpToNextBusinessDay(range[0]);
        var end    = range.length > 1 ? bumpToNextBusinessDay(range[1]) : start;
        if (start < policy.earliest) {
            start = policy.earliest;
        }
        if (end < start) {
            end = start;
        }
        if (end < policy.latestMin) {
            end = policy.latestMin;
        }
        return range.length > 1 ? [start, end] : [start];
    }

    function rateDisplayRange(rate) {
        var preferred = getPreferredDate();
        if (preferred) {
            return {range: [preferred, preferred], estimated: false};
        }

        var range;
        var estimated;
        if (rate.delivery_range && rate.delivery_range.length) {
            range     = rate.delivery_range;
            estimated = !!rate._carrier_missing_range;
        } else {
            rate._carrier_missing_range = true;
            range                       = fallbackRangeForRate(rate);
            estimated                   = true;
        }

        return {range: normalizeRange(range), estimated: estimated};
    }

    function renderRates(rates) {
        $rates.empty();

        if (!rates || !rates.length) {
            lastRates = null;
            $rates.attr('hidden', 'hidden');
            $summary.text(defaultSummary);
            setStatus(t('cart.general.shipping_estimator_error_none'));
            return;
        }

        var sorted = rates.slice().sort(function (a, b) {
            return parseFloat(a.price) - parseFloat(b.price);
        });
        lastRates  = sorted;

        sorted.forEach(function (rate, idx) {
            var $li     = $('<li class="cart__shipping-rate"></li>');
            var inputId = 'ShippingRate-' + idx;
            $li.html(
                '<label for="' + inputId + '">' +
                '<input type="radio" id="' + inputId + '" name="cart_shipping_rate" value="' + idx + '"' + (idx === selectedRateIdx ? ' checked' : '') + '> ' +
                '<span class="cart__shipping-rate__name">' + $('<div>').text(rate.name).html() + '</span> ' +
                '<span class="cart__shipping-rate__price">' + formatMoney(rate.price) + '</span>' +
                '</label>'
            );
            $li.find('input').on('change', function () {
                selectedRateIdx = parseInt($(this).val(), 10);
                applySummary(sorted[selectedRateIdx]);
            });
            $rates.append($li);
        });

        $rates.removeAttr('hidden');
        if (selectedRateIdx >= sorted.length) {
            selectedRateIdx = 0;
        }
        applySummary(sorted[selectedRateIdx]);
        setStatus('');
    }

    function applySummary(rate) {
        if (!rate) {
            $summary.text(defaultSummary);
            return;
        }
        var info      = rateDisplayRange(rate);
        var html      = '<span class="cart__shipping-summary__price">' +
                        t('cart.general.shipping_estimator_estimate_html', {price: formatMoney(rate.price)}) +
                        '</span>';
        var rangeText = formatDeliveryRange(info.range);
        if (rangeText) {
            html += '<span class="cart__shipping-summary__range">' +
                    t('cart.general.shipping_estimator_delivery_range_estimated_html', {range: rangeText}) +
                    '</span>';
        }
        $summary.html(html);
    }

    function pollRates(attempts) {
        attempts = attempts || 0;
        if (attempts > 10) {
            setStatus(t('cart.general.shipping_estimator_error_generic'));
            inflight = false;
            return;
        }
        $.ajax({
            type    : 'GET',
            url     : '/cart/async_shipping_rates.json',
            dataType: 'json'
        }).done(function (data) {
            if (data && data.shipping_rates) {
                inflight = false;
                renderRates(data.shipping_rates);
            } else {
                setTimeout(function () {
                    pollRates(attempts + 1);
                }, 500);
            }
        }).fail(function () {
            inflight = false;
            setStatus(t('cart.general.shipping_estimator_error_generic'));
        });
    }

    function fetchRates(country, zip, province, opts) {
        if (inflight) {
            return;
        }
        opts = opts || {};
        if (!country || !zip) {
            if (!opts.silent) {
                setStatus(t('cart.general.shipping_estimator_error_required'));
            }
            return;
        }

        inflight = true;
        setStatus(t('cart.general.shipping_estimator_loading'));
        $rates.attr('hidden', 'hidden').empty();

        var payload = {
            'shipping_address[country]': country,
            'shipping_address[zip]'    : zip
        };
        if (province) {
            payload['shipping_address[province]'] = province;
        }

        $.ajax({
            type: 'POST',
            url : '/cart/prepare_shipping_rates.json',
            data: payload
        }).done(function () {
            pollRates(0);
        }).fail(function (xhr) {
            inflight = false;

            if (xhr.status >= 200 && xhr.status < 300) {
                inflight = true;
                pollRates(0);
                return;
            }

            var msg = t('cart.general.shipping_estimator_error_generic');
            try {
                var resp = xhr.responseJSON || (xhr.responseText ? JSON.parse(xhr.responseText) : null);
                if (resp && resp.shipping_address) {
                    msg = [].concat(resp.shipping_address).join(' ');
                }
            } catch (e) {
            }
            setStatus(msg);
        });
    }

    return {
        refresh: function () {
            if (lastRates && lastRates.length) {
                renderRates(lastRates);
            }
        },
        init   : function () {
            $root = $('.js-shipping-estimator');
            if (!$root.length) {
                return;
            }
            $zip           = $root.find('.js-shipping-estimator-zip');
            $province      = $root.find('.js-shipping-estimator-province');
            $btn           = $root.find('.js-shipping-estimator-submit');
            $status        = $root.find('.js-shipping-estimator-status');
            $rates         = $root.find('.js-shipping-estimator-rates');
            $summary       = $('.js-shipping-estimator-summary');
            defaultSummary = $summary.data('default-text') || $summary.text();

            var cached = loadCache();
            if (cached.province) {
                $province.val(cached.province);
            }
            if (cached.zip) {
                $zip.val(cached.zip);
            }

            $btn.on('click', function () {
                var zip      = ($zip.val() || '').trim();
                var province = $province.val() || '';
                saveCache({zip: zip, province: province});
                fetchRates(SHIP_COUNTRY, zip, province);
            });

            if (cached.zip) {
                fetchRates(SHIP_COUNTRY, cached.zip, cached.province, {silent: true});
            }
        }
    };
})();

$(document).ready(function () {
    collectionFilter.init();
    theme.Cart();
    starColorOverride();
    rebuyStyle();
    if (theme.ShippingEstimator && theme.ShippingEstimator.init) {
        theme.ShippingEstimator.init();
    }
});
